import Introduction from "./screens/Introduction";
import HomeSections from "./HomeSections";

const Home = () => {
  return (
    <div>
      <Introduction />
      <HomeSections />
    </div>
  );
};

export default Home;
